// Generated by purs version 0.15.0
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Record from "../Record/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var rsequence = function () {
    return function (dictApplicative) {
        return function (dictSequenceRecord) {
            return Record_Extra.sequenceRecord()(dictSequenceRecord);
        };
    };
};
var rsequence2 = function (dictFunctor) {
    return function () {
        return function (dictApplicative) {
            return function (dictSequenceRecord) {
                return function () {
                    return function (dictApplicative1) {
                        return function (dictSequenceRecord1) {
                            var $15 = Data_Functor.map((dictApplicative1.Apply0()).Functor0())(rsequence()(dictApplicative)(dictSequenceRecord));
                            var $16 = rsequence()(dictApplicative1)(dictSequenceRecord1);
                            return function ($17) {
                                return $15($16($17));
                            };
                        };
                    };
                };
            };
        };
    };
};
var mapFieldRecordNil = {
    mapFieldRecordImpl: function (v) {
        return function (v1) {
            return function (v2) {
                return {};
            };
        };
    }
};
var mapFieldRecordImpl = function (dict) {
    return dict.mapFieldRecordImpl;
};
var mapFieldRecordCons = function (dictIsSymbol) {
    return function () {
        return function (dictMapFieldRecord) {
            return function () {
                return function () {
                    return {
                        mapFieldRecordImpl: function (v) {
                            return function (f) {
                                return function (r) {
                                    var rest = mapFieldRecordImpl(dictMapFieldRecord)(Type_Proxy["Proxy"].value)(f)(r);
                                    var val = f(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value))(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(r));
                                    return Record.insert(dictIsSymbol)()()(Type_Proxy["Proxy"].value)(val)(rest);
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var mapFieldRecord = function () {
    return function (dictMapFieldRecord) {
        return mapFieldRecordImpl(dictMapFieldRecord)(Type_Proxy["Proxy"].value);
    };
};
export {
    rsequence,
    rsequence2,
    mapFieldRecordImpl,
    mapFieldRecord,
    mapFieldRecordCons,
    mapFieldRecordNil
};
//# sourceMappingURL=index.js.map
